import { Facebook, LoaderCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button';
import { useMetaOAuth } from '@/hooks/useMetaOAuth';

export function MetaOAuth() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.Meta.MetaOAuth',
  });
  const { isLoading, metaOAuth } = useMetaOAuth();

  async function handleMetaOAuth() {
    const { data } = await metaOAuth();

    if (data?.url) {
      window.open(data.url, '_blank');
    }
  }

  return (
    <div className="space-y-4">
      <div className="rounded-lg bg-gray-100 p-4">
        <h3 className="mb-2 text-lg font-semibold">{t('title')}</h3>
        <ul className="list-inside list-disc space-y-2">
          <li>{t('item1')}</li>
          <li>{t('item2')}</li>
          <li>{t('item3')}</li>
          <li>{t('item4')}</li>
          <li>{t('item5')}</li>
        </ul>
      </div>

      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">{t('description')}</p>

        <Button
          onClick={handleMetaOAuth}
          className="w-full bg-[#1877F2] text-white transition-colors hover:bg-[#0C63D4]"
        >
          {isLoading && <LoaderCircle className="animate-spin" />}

          {!isLoading && (
            <>
              <Facebook className="mr-2 h-4 w-4" />
              {t('connectButton')}
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
